"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CardTitle = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var CardTitle = function (_a) {
    var children = _a.children;
    return (0, jsx_runtime_1.jsx)("h1", { className: "text-xl mb-4", children: children });
};
exports.CardTitle = CardTitle;
